import { User } from '@project44/ui-utils';

import { NavigationLink } from '../types';

export const getNavigationLinks = ({
  user,
  flags,
  links,
}: {
  user?: User;
  flags?: Record<string, boolean>;
  links: NavigationLink[];
}): NavigationLink[] => {
  const authLinks: NavigationLink[] = [];

  links.forEach((link) => {
    if (!link.guard || link.guard({ user, flags })) {
      authLinks.push({
        ...link,
        subNavigation: link?.subNavigation
          ? getNavigationLinks({ user, flags, links: link.subNavigation })
          : undefined,
      });
    }
  });

  return authLinks;
};
